import {DocumentData} from "@angular/fire/firestore";
import {removeElement} from "@fullcalendar/angular";
import * as hexRgb from "hex-rgb";

export class Utils {

  public static validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  public static isEmpty(str: string) {
    return (!str || 0 === str.toString().trim().length);
  }

  public static sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public static uidInjector(document: DocumentData) {
    const data = document.data();
    Object.assign(data, { uid: document.id });
    return data;
  }

  public static round2decimals(num: number) {
    return Math.round((num + Number.EPSILON) * 100) / 100
  }

  public static getTime2Seconds(time: number) {
    return Math.round(time % 60);
  }
  public static getTime2Minutes(time: number) {
    return Math.floor(time / 60) - this.getTime2Hours(time);
  }
  public static getTime2Hours(time: number) {
    return Math.floor(time / 3600);
  }
  public static getTime(hours: number, minutes: number, seconds: number) {
    if (hours > 0) {
      return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
    } else {
      return minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
    }
  }

  public static randomString(length) {
    let result           = '';
    const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  public static arrayFlat(array: any[]) {
    return [].concat.apply([], array);
  }

  public static get today(): Date {
    const today = new Date();
    today.setMilliseconds(0);
    today.setSeconds(0);
    today.setMinutes(0);
    today.setHours(0);
    return today;
  }

  public static setToHappen(foo: Function, date: Date){
    const t = date.getTime() - (new Date()).getTime();
    return setTimeout(foo, t);
  }

  public static get emailPattern() {
    return '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$';
  }

  public static getExtension(fileName: string): string {
    return fileName.split('.').pop();
  }

  public static getExtensionFromFile(file: File): string {
    return file.name.split('.').pop();
  }

  public static downloadImageFromCanvas(canvasElement: HTMLCanvasElement, filename: string) {
    const imageURI = canvasElement.toDataURL("image/jpg");
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = imageURI;
    // the filename you want
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(imageURI);
    removeElement(a);
  }

  public static range(n) {
    return Array.from({length: n}, (value, key) => key)
  }

  public static enumToArray(e) {
    return this.range(Object.keys(e).length / 2);
  }

  public static hexToRgbString(hexString: string) {
    const rgab = hexRgb(hexString);
    return `${rgab.red},${rgab.green},${rgab.blue}`;
  }

  public static getZeroDate() {
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }

  // Check if URL is absolute or relative
  public static isAbsoluteUrl(url: string) {
    return /^(?:[a-z]+:)?\/\//i.test(url);
  }

}
